import React from 'react';
import { Badge, Button } from 'rsuite';
import * as header from './card-viewer-header-styles';

export function IconButtonWithTitle(props) {
  const { title, filterCount, filterButtonRef, disabled = false, icon } = props;

  const badgeContent = !filterCount ? false : filterCount;

  return (
    <Badge content={badgeContent}>
      <header.IconButtonWrapper
        ref={filterButtonRef}
        id={title.toLowerCase()}
        disabled={disabled}
      >
        <Button size="sm" startIcon={icon}>
          <div>{title}</div>
        </Button>
      </header.IconButtonWrapper>
    </Badge>
  );
}
